import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { CommonService } from './common.service';
import { Observable } from 'rxjs';
@Injectable()

export class PermissionsGuardService implements CanActivate {

  private pagePermissions = {
    '/bookings': {name: 'My Bookings'},
    '/bookings/create': {name: 'Create Booking'},
    // '/bookings-new/create': {name: 'Create Booking'},
    '/requests-view': {name: 'Request View'},
    '/bookings-view': {name: 'Booking View'},
    // '/bookings-view-new': {name: 'Booking View'},
    '/bookings-filtered-view': {name: 'Booking View'},
    '/bookings-filtered-vendor-view': {name: 'Booking View'},
    '/bookings-filtered-cab-view': {name: 'Booking View'},
    '/billing-report': {name: 'Billing Reports'},
    '/invoicing': {name: 'Invoicing'},
    '/bookings/bulk-create': {name: 'Bulk Booking'},
    '/profile': {name: 'My Profile'},
    '/tracking': {name: 'Tracking'},
    '/auto-vendor-allocation': {name: 'AVA'},
    '/vehicle-allocation': {name: 'Designation'}
  };

  private isPermissionsSet: boolean;

  constructor(private commonService: CommonService, private router: Router) { }

  public setPagePermissions(config) {
    const sideBarConfig =  this.commonService.getConfigForElementKey(config, 'Side Bar');
    Object.values(this.pagePermissions).forEach((page: any) => {
      page.hasAccess = this.commonService.getConfigForElementKey(sideBarConfig, page.name).config?.visibility.visible
      ;
    });
    this.isPermissionsSet = true;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>|boolean  {
    if (this.isPermissionsSet) {
      return this.pagePermissions[state.url] ? this.pagePermissions[state.url].hasAccess : true;
    } else {
      return new Observable(observer => {
        this.commonService.fetchConfig().subscribe((config) => {
          this.setPagePermissions(config);
          if (this.pagePermissions[state.url] && this.pagePermissions[state.url].hasAccess) {
            observer.next(true);
          } else {
            this.router.navigate(['404']);
          }
          observer.complete();
        });
      });
    }
  }

  clearPagePermissions() {
    Object.values(this.pagePermissions).forEach((page: any) => {
      page.hasAccess = false;
    });
    this.isPermissionsSet = false;
  }
}
